interface DatasetErrorProps {
  /** The route's 502 payload detail, when available. */
  message?: string;
  fetchedAt?: string;
}

/**
 * Dataset-unreachable state. Deliberately distinct from the empty state:
 * "the crawler ran and found nothing" must never look like "the pipeline is
 * down".
 */
export default function DatasetError({ message, fetchedAt }: DatasetErrorProps) {
  return (
    <div className="border border-red-200 rounded-lg bg-red-50 p-4 space-y-1">
      <h2 className="text-sm font-semibold text-red-800">PC Monitor dataset unreachable</h2>
      <p className="text-sm text-red-700">
        The crawler may not have run, or the pull from sr-aya has not landed on this host. This is
        an infrastructure state — it is not a quiet market.
      </p>
      {message && <p className="text-xs font-mono text-red-600 break-all">{message}</p>}
      {fetchedAt && <p className="text-xs text-red-400">Attempted {fetchedAt}</p>}
    </div>
  );
}
